import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "detail_container" }
const _hoisted_2 = { class: "detail_base-info card-white-6" }
const _hoisted_3 = { class: "detail_header" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "title" }, "合同信息", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ")
const _hoisted_6 = { style: {"display":"inline-flex","margin-left":"4px"} }
const _hoisted_7 = { style: {"margin-right":"4px","display":"inline-flex"} }
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"display":"flex","flex-direction":"column"} }
const _hoisted_10 = { style: {"padding":"4px 4px","font-size":"16px","font-weight":"700"} }
const _hoisted_11 = { style: {"padding":"4px 4px","display":"inline-flex"} }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"70px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "关联主体：")
], -1)
const _hoisted_13 = {
  key: 0,
  style: {"font-weight":"bold"}
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"#aaa"} }, "(实控主体)", -1)
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { style: {"padding":"4px 4px","display":"inline-flex"} }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { style: {"width":"70px"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "标签：")
], -1)
const _hoisted_18 = { style: {"display":"flex"} }
const _hoisted_19 = { class: "riskTag" }
const _hoisted_20 = {
  class: "riskNum",
  style: {"margin-bottom":"0px"}
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_23 = {
  key: 0,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_24 = ["href"]
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 下载扫描件 ")
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 同步飞书合同 ")
const _hoisted_28 = {
  key: 1,
  class: "hw_detail_table_container card-white-6"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "hw_detail_table_header" }, [
  /*#__PURE__*/_createElementVNode("span", {
    class: "title",
    style: {"font-size":"16px","font-weight":"bold"}
  }, "合同存档")
], -1)
const _hoisted_30 = { class: "px-4 py-2" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "we-table-span we-nodata"
}
const _hoisted_39 = { class: "hw_detail_table_container card-white-6" }
const _hoisted_40 = { style: {"background":"white","padding":"20px"} }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2 we-title3" }, "Default Templates:", -1)
const _hoisted_42 = { style: {"text-align":"right"} }
const _hoisted_43 = /*#__PURE__*/_createTextVNode("Ask for Template from Legal")
const _hoisted_44 = ["onClick"]
const _hoisted_45 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_WeEditableWarp = _resolveComponent("WeEditableWarp")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_InlineList = _resolveComponent("InlineList")!
  const _component_EmailCards = _resolveComponent("EmailCards")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_EntityList = _resolveComponent("EntityList")!
  const _component_we_table = _resolveComponent("we-table")!
  const _component_contract_config = _resolveComponent("contract-config")!
  const _component_FlowTimeLine = _resolveComponent("FlowTimeLine")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_LegalAffairs = _resolveComponent("LegalAffairs")!
  const _component_page_detail_wrapper = _resolveComponent("page-detail-wrapper")!
  const _directive_loading = _resolveDirective("loading")!

  return (!_ctx.isEmptyData(_ctx.contract))
    ? _withDirectives((_openBlock(), _createBlock(_component_page_detail_wrapper, _mergeProps({
        key: 0,
        title: _ctx.contract.name + (_ctx.contract.is_deleted ? ' [DELETED]' : ''),
        drop_down_menus: _ctx.moreActions,
        collapsed: true
      }, _ctx.$attrs), {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                (_ctx.canEdit)
                  ? (_openBlock(), _createBlock(_component_a_button, {
                      key: 0,
                      class: "mglf-16",
                      type: "primary",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editContract(_ctx.contract, _ctx.afterEditContract)))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_svg_icon, { "icon-name": "EditOutlined" })
                      ]),
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_a_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    gutter: 20,
                    type: "flex",
                    style: {"flex-wrap":"wrap"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "对方主体",
                            name: "show_company_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.show_company_name
                              }, {
                                text: _withCtx(() => [
                                  (_ctx.company.is_linked)
                                    ? (_openBlock(), _createBlock(_component_a_popover, {
                                        key: 0,
                                        placement: "bottomRight"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_6, [
                                            _createElementVNode("div", _hoisted_7, [
                                              _createElementVNode("img", {
                                                src: _ctx.corpNameImg()
                                              }, null, 8, _hoisted_8)
                                            ]),
                                            _createElementVNode("div", _hoisted_9, [
                                              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.company.name), 1),
                                              _createElementVNode("div", _hoisted_11, [
                                                _hoisted_12,
                                                _createElementVNode("div", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.group, (c, i) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                      key: i,
                                                      style: {"display":"flex","white-space":"nowrap","margin-right":"4px"}
                                                    }, [
                                                      (c.is_controlling)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                            _createTextVNode(_toDisplayString(c.name) + " ", 1),
                                                            _hoisted_14
                                                          ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(c.name), 1))
                                                    ]))
                                                  }), 128))
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_16, [
                                                _hoisted_17,
                                                _createElementVNode("div", null, [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.company.qcc_info?.tags, (k, i) => {
                                                    return (_openBlock(), _createBlock(_component_a_tag, {
                                                      key: i,
                                                      style: {"max-width":"max-content"}
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(k), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1024))
                                                  }), 128))
                                                ])
                                              ])
                                            ])
                                          ]),
                                          _createElementVNode("div", _hoisted_18, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.riskCount, (risk, i) => {
                                              return (_openBlock(), _createBlock(_component_a_card, {
                                                class: _normalizeClass(["risk1", { hasNum: risk.num > 0 }]),
                                                style: {"background":"#fff0ee","margin":"4px 4px","padding":"8px"},
                                                key: i
                                              }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("p", _hoisted_19, _toDisplayString(risk.tag), 1),
                                                  _createElementVNode("p", _hoisted_20, _toDisplayString(risk.num), 1)
                                                ]),
                                                _: 2
                                              }, 1032, ["class"]))
                                            }), 128))
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            type: "link",
                                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.jumpToCompany(_ctx.contract.company_id))),
                                            style: {"white-space":"pre-wrap"}
                                          }, _toDisplayString(_ctx.contract.show_company_name), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createElementBlock("a", {
                                        key: 1,
                                        type: "link",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.jumpToCompany(_ctx.contract.company_id))),
                                        style: {"white-space":"pre-wrap"}
                                      }, _toDisplayString(_ctx.contract.show_company_name), 1))
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 12 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "我方主体",
                            name: "show_we_company_name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: `${_ctx.contract.show_we_company_name}`
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "国别" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.company.country.code
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "业务空间",
                            name: "rd_logic_type"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: _ctx.contract.rd_logic_type
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (!_ctx.isBackupItem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "起始日期",
                                  name: "show_begin_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.contract.show_begin_time
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "终止日期",
                                  name: "show_end_time"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.contract.show_end_time
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_col, { span: 6 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: "合同归属",
                            name: "name"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_WeEditableWarp, {
                                value: 
                    _ctx.contract.owner.name +
                    (_ctx.contract.rd_tracker_name ? '/' + _ctx.contract.rd_tracker_name : '') +
                    ' (' +
                    _ctx.contract.team.name +
                    ')'
                  
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      (_ctx.isBusinessItem)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "账单归属",
                                name: "am_name"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: 
                    _ctx.contract.am.name +
                    (_ctx.contract.rd_bill_tracker_name ? '/' + _ctx.contract.rd_bill_tracker_name : '') +
                    ' (' +
                    _ctx.contract.am_team.name +
                    ')'
                  
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isBackupItem)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 2,
                            span: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "创建时间",
                                name: "create_time"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.contract.create_time
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isPurchaseItem)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 3,
                            span: 6
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "币种",
                                name: "currency"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_WeEditableWarp, {
                                    value: _ctx.contract.currency ? _ctx.contract.currency.name : ''
                                  }, null, 8, ["value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (_ctx.isBusinessItem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                            _createVNode(_component_a_divider, { style: {"margin":"5px 0"} }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "币种",
                                  name: "currency"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.contract.currency ? _ctx.contract.currency.name : ''
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_col, { span: 6 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "付款类型",
                                  name: "rd_property_name"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.contract.rd_property_name
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (!_ctx.contract.is_no_bills)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "生成账单",
                                      name: "gen_bill_type_name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.gen_bill_type_name + (_ctx.contract.is_parent ? ', M/S账单' : ', N账单')
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.contract.is_parent)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "账单拆分" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_InlineList, {
                                          dataList: _ctx.contract.split_list.map((x) => x.name),
                                          canEdit: _ctx.canSplit,
                                          addFunc: _ctx.setBulines,
                                          addButtonSpan: "设置"
                                        }, null, 8, ["dataList", "canEdit", "addFunc"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(_component_a_col, {
                                  key: 2,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "业务线" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.contract.rd_bulines), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })),
                            _createVNode(_component_a_col, { span: 12 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "业务标签",
                                  name: "rd_logic_detail"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_WeEditableWarp, {
                                      value: _ctx.contract.rd_logic_detail
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.contract.is_normal || _ctx.contract.is_prepay)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 3,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "对账期",
                                      name: "show_check_bill_time_point"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: 
                      _ctx.contract.show_check_bill_time_point +
                      (_ctx.contract.check_bill_timespan ? ' / ' + _ctx.contract.check_bill_timespan + ' Days' : '')
                    
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.contract.is_normal || _ctx.contract.is_prepay)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 4,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: _ctx.contract.is_demand ? '收款期' : '付款期',
                                      name: "show_pay_money_time_point"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: 
                      _ctx.contract.show_pay_money_time_point +
                      (_ctx.contract.pay_money_timespan ? ' / ' + _ctx.contract.pay_money_timespan + ' Days' : '')
                    
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isCloudLogic || (_ctx.isScalerLogic && _ctx.contract.is_demand))
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 5,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: _ctx.isCloudLogic ? 'Cloud税率' : '税率',
                                      name: "cloud_tax"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.formatNumberByNumeral(_ctx.contract.cloud_tax, '0.00%')
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    }, 8, ["label"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isMediaLogic)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 6,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "预警邮件类型",
                                      name: "rd_email_template_name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.rd_email_template_name
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.contract.is_demand && _ctx.isMediaLogic)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 7,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "是否双签",
                                      name: "ugs_sign_type"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.ugs_sign_type
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      (!_ctx.isBackupItem)
                        ? (_openBlock(), _createBlock(_component_a_divider, {
                            key: 5,
                            style: {"margin":"5px 0"}
                          }))
                        : _createCommentVNode("", true),
                      (!_ctx.isBusinessItem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                            (_ctx.isPurchaseItem)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "银行名称" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.bank.bf_bank
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isPurchaseItem)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "银行账号" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.bank.bf_account_number
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isPurchaseItem && _ctx.isOversea)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 2,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "Swift Code" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.bank.bf_swift_code
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isPurchaseItem && _ctx.isOversea)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 3,
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "银行地址" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.bank.bf_bank_address
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isBackupItem)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 4,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "我方银行" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.we_company_bank.bf_bank
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (!_ctx.isBackupItem)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 5,
                                  span: 12
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "我方银行账号" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.we_company_bank.bf_account_number
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.showAutoInvoice)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 6,
                                  span: 6
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "开票方式" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.is_manual_invoice ? '人工开票' : '自动开票'
                                        }, null, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_ctx.isOversea)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                              (_ctx.contract.company.country.code === 'US')
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 0,
                                    span: 6
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "州" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.company.country_state
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_a_col, {
                                span: _ctx.contract.company.country.code === 'US' ? 18 : 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "开票地址" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.company.invoice_address
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["span"]),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "对方银行" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_bank
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "银行账号" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_account_number
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "Swift Code" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_swift_code
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "银行地址" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_bank_address
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (!_ctx.isBackupItem)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 1,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "我方银行" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.we_company_bank.bf_bank
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isBackupItem)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 2,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "我方银行账号" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.we_company_bank.bf_account_number
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.showAutoInvoice)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 3,
                                    span: 6
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "开票方式" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.is_manual_invoice ? '人工开票' : '自动开票'
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "纳税人识别号" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.company.tax_number
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "开票电话" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.company.invoice_phone
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "开票地址" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.company.invoice_address
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "对方银行" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_bank
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_col, { span: 12 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "银行账号" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_WeEditableWarp, {
                                        value: _ctx.contract.bank.bf_account_number
                                      }, null, 8, ["value"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (!_ctx.isBackupItem)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 0,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "我方银行" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.we_company_bank.bf_bank
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.isBackupItem)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 1,
                                    span: 12
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "我方银行账号" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.we_company_bank.bf_account_number
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.showAutoInvoice)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 2,
                                    span: 6
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "开票方式" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_WeEditableWarp, {
                                            value: _ctx.contract.is_manual_invoice ? '人工开票' : '自动开票'
                                          }, null, 8, ["value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ], 64)),
                      (_ctx.isBusinessItem)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                            (
                  _ctx.contract.opp_list.length > 0 ||
                  _ctx.contract.opp ||
                  _ctx.contract.related_contract_id ||
                  _ctx.isMediaLogic ||
                  _ctx.isCloudLogic
                )
                              ? (_openBlock(), _createBlock(_component_a_divider, {
                                  key: 0,
                                  style: {"margin":"5px 0"}
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.contract.opp_list.length > 0)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 1,
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, {
                                      label: "客户跟进",
                                      name: "name"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, null, {
                                          text: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contract.opp_list, (opp, i) => {
                                              return (_openBlock(), _createElementBlock("span", {
                                                class: "px-0 py-2",
                                                key: i
                                              }, [
                                                _createElementVNode("a", {
                                                  onClick: ($event: any) => (_ctx.jumpToOpp(opp.id))
                                                }, _toDisplayString(opp.name), 9, _hoisted_21),
                                                (i < _ctx.contract.opp_list.length - 1)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.contract.opp)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 2,
                                    span: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "客户跟进",
                                        name: "name"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("a", {
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.jumpToOpp(_ctx.contract.opp.id)))
                                          }, _toDisplayString(_ctx.contract.opp.name), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                            (_ctx.contract.related_contract_id)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 3,
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_form_item, { label: "内部关联合同" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_WeEditableWarp, {
                                          value: _ctx.contract.rd_related_contract_name
                                        }, {
                                          text: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createVNode(_component_a_button, {
                                                type: "link",
                                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.jumpToContract({ id: _ctx.contract.related_contract_id })))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.contract.rd_related_contract_name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["value"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            (_ctx.isMediaLogic || _ctx.isCloudLogic)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 4,
                                  span: 24
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_EmailCards, {
                                      contract: _ctx.contract,
                                      onOnUpdate: _ctx.afterEditContract
                                    }, null, 8, ["contract", "onOnUpdate"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_EntityList, {
              config: _ctx.cfiConfig,
              items: _ctx.contract.company_finance_info_apply_list,
              title: "客商信息申请",
              onJumpTo: _ctx.jumpToCfiDetail,
              headerButtonConfig: _ctx.cfiButtonConfig
            }, null, 8, ["config", "items", "onJumpTo", "headerButtonConfig"]),
            (!_ctx.isEmptyData(_ctx.lark_contracts))
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createVNode(_component_we_table, _mergeProps({ dataSource: _ctx.lark_contracts }, _ctx.larkContractConfig), {
                    contract_number: _withCtx(({ text, record }) => [
                      _createElementVNode("a", {
                        href: record.url,
                        target: "_blank"
                      }, _toDisplayString(text), 9, _hoisted_24)
                    ]),
                    action: _withCtx(({ record }) => [
                      (_ctx.isGod || _ctx.isLegal || _ctx.isMine || _ctx.isFinance)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "link",
                            danger: "",
                            onClick: ($event: any) => (_ctx.delete_lark_contract(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      ([8, 9].includes(record.status_code))
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "link",
                            onClick: ($event: any) => (_ctx.download_lark_contract_scan(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.isGod || _ctx.isLegal || _ctx.isMine || _ctx.isFinance)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 2,
                            type: "link",
                            onClick: ($event: any) => (_ctx.sync_lark_contract(record))
                          }, {
                            default: _withCtx(() => [
                              _hoisted_27
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 16, ["dataSource"])
                ]))
              : _createCommentVNode("", true),
            ((_ctx.isLegal || _ctx.isAdmin) && _ctx.archiveList && _ctx.archiveList.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_we_table, _mergeProps(_ctx.archiveConfig, { dataSource: _ctx.archiveList }), {
                      name: _withCtx(({ record }) => [
                        _createElementVNode("a", {
                          class: "we-table-span",
                          onClick: ($event: any) => (_ctx.editArchive('edit', record))
                        }, _toDisplayString(record.archive_name), 9, _hoisted_31)
                      ]),
                      files: _withCtx(({ record }) => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.files.filter((f) => !_ctx.isEmptyData(f.path)), (file, index) => {
                          return (_openBlock(), _createElementBlock("a", {
                            class: "we-table-span",
                            key: index,
                            onClick: ($event: any) => (_ctx.downloadArchiveAttachFile(file.name, file.path))
                          }, _toDisplayString(file.name), 9, _hoisted_32))
                        }), 128)),
                        ((record.files.filter((f) => !_ctx.isEmptyData(f.path)) || []).length === 0)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "-"))
                          : _createCommentVNode("", true)
                      ]),
                      action: _withCtx(({ record }) => [
                        (_ctx.hasPermission(['RoleArchiveManager']))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                              _createElementVNode("a", {
                                class: "we-table-span",
                                onClick: ($event: any) => (_ctx.editArchive('delete', record))
                              }, "删除", 8, _hoisted_35)
                            ]))
                          : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                              (!record.is_confirmed)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "we-table-span",
                                    onClick: ($event: any) => (_ctx.editArchive('delete', record))
                                  }, "删除", 8, _hoisted_37))
                                : (_openBlock(), _createElementBlock("span", _hoisted_38, "—"))
                            ]))
                      ]),
                      _: 1
                    }, 16, ["dataSource"])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_contract_config, {
              contract: _ctx.contract,
              canEdit: _ctx.canEdit,
              onOnUpdateConfig: _ctx.afterEditContract
            }, null, 8, ["contract", "canEdit", "onOnUpdateConfig"]),
            (_ctx.contract && _ctx.isPrepay && _ctx.contract.prepay_list && _ctx.contract.prepay_list.length)
              ? (_openBlock(), _createBlock(_component_EntityList, {
                  key: 2,
                  config: _ctx.prepayConfig,
                  items: _ctx.contract.prepay_list,
                  title: "预付列表",
                  onJumpTo: _ctx.jumpToPay
                }, null, 8, ["config", "items", "onJumpTo"]))
              : _createCommentVNode("", true),
            (_ctx.isPurchaseItem && _ctx.contract.pay_list && _ctx.contract.pay_list.length > 0)
              ? (_openBlock(), _createBlock(_component_EntityList, {
                  key: 3,
                  config: _ctx.linkPayListConfig,
                  items: _ctx.contract.pay_list,
                  title: "付款列表",
                  onJumpTo: _ctx.jumpToPay
                }, null, 8, ["config", "items", "onJumpTo"]))
              : _createCommentVNode("", true),
            (_ctx.contract.bill_list && _ctx.contract.bill_list.length)
              ? (_openBlock(), _createBlock(_component_EntityList, {
                  key: 4,
                  config: _ctx.billConfig,
                  items: _ctx.contract.bill_list,
                  title: "账单",
                  onJumpTo: _ctx.jumpToBill
                }, null, 8, ["config", "items", "onJumpTo"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_39, [
              (!_ctx.isEmptyData(_ctx.contract.flow))
                ? (_openBlock(), _createBlock(_component_FlowTimeLine, {
                    key: 0,
                    ref: "flowtimeline",
                    flow: _ctx.contract.flow,
                    onOnCatchFlag: _ctx.catchFlowFlag,
                    onOnUpdate: _ctx.afterEditContract
                  }, null, 8, ["flow", "onOnCatchFlag", "onOnUpdate"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_a_modal, {
            visible: _ctx.templateDialog,
            "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.templateDialog) = $event)),
            width: "1000px"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _createVNode(_component_we_table, _mergeProps(_ctx.templateConfig, { dataSource: _ctx.templateList }), {
                  name: _withCtx(({ record }) => [
                    _createVNode(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (_ctx.downloadTemplate(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.rd_file_name), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 16, ["dataSource"]),
                _createElementVNode("div", _hoisted_42, [
                  _createVNode(_component_a_tooltip, { title: "无适合模版，仍需法务上传合同模版" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        onClick: _ctx.askTemplate,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_a_modal, {
            visible: _ctx.show_edit_bulines,
            "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.show_edit_bulines) = $event)),
            centered: "",
            width: "600px",
            closable: false,
            title: "设置业务线"
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.show_edit_bulines = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_45
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _ctx.saveBulines
              }, {
                default: _withCtx(() => [
                  _hoisted_46
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_a_table, _mergeProps(_ctx.bulinesTableConfig, {
                dataSource: _ctx.bulineSplitList,
                pagination: false
              }), {
                team_id: _withCtx(({ record }) => [
                  _createVNode(_component_we_select, {
                    value: record.team_id,
                    "onUpdate:value": ($event: any) => ((record.team_id) = $event),
                    options: _ctx.teamOptions
                  }, null, 8, ["value", "onUpdate:value", "options"])
                ]),
                am_id: _withCtx(({ record }) => [
                  _createVNode(_component_we_select, {
                    value: record.am_id,
                    "onUpdate:value": ($event: any) => ((record.am_id) = $event),
                    options: _ctx.getAmOptions(record.team_id)
                  }, null, 8, ["value", "onUpdate:value", "options"])
                ]),
                action: _withCtx(({ record }) => [
                  (_ctx.bulineSplitList.length > 1)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        style: {"margin-left":"8px"},
                        onClick: ($event: any) => (_ctx.removeBuline(record))
                      }, "删除", 8, _hoisted_44))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 16, ["dataSource"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_LegalAffairs, {
            contract: _ctx.contract,
            ref: "LegalAffairsRef"
          }, null, 8, ["contract"])
        ]),
        _: 1
      }, 16, ["title", "drop_down_menus"])), [
        [_directive_loading, _ctx.contractDetailLoading]
      ])
    : _createCommentVNode("", true)
}